exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "section.fund-scanner {\n  padding: 0;\n}\n.mf-view {\n  height: calc(100vh - 240px);\n}\n@media (max-width: 1100px) and (orientation: landscape) {\n.mf-view {\n    height: 150vh;\n}\n}\n@media (max-width: 600px) {\n.mf-view {\n    height: calc(100vh);\n}\n}\n", ""]);
